import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from 'react-i18next';
import Header from "../../components/header";
import api from "../../api/api";
import Payment_history from "./paymentHistory/paymentHistory";
import Due_details from "./dueDetails/dueDetail";
import filter from "../../assets/header/filter.png";
import { numToCurrency } from "../../utils/currency";
import Loader from "../../components/loader";


function Fees(props) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("due");
  const [feesData, setFeesData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [localSelectedYear, setLocalSelectedYear] = useState(null);
  const [fineEnable,setFineEnable]=useState(false)
  const [isTransportChecked, setIsTransportChecked] = useState(false);
  const [isTransportApplicable, setIsTransportApplicable] = useState(false);
  const globalSelectedYear = props.auth.selectedAcadYear;  
  
  
  useEffect(() => {
    if (props.auth.acad_year_list.length > 0) {
      let defaultYear;
  
      // ✅ First priority: academic year marked as default
      defaultYear = props.auth.acad_year_list.find(
        (year) => year.default_academic_year === 1
      );
  
      // ✅ Second priority: if institute type is school & globalSelectedYear exists
      if (!defaultYear && props.auth.is_institute_type_school && globalSelectedYear) {
        defaultYear = props.auth.acad_year_list.find(
          (year) => year.inst_acad_year_id === globalSelectedYear.inst_acad_year_id
        );
      }
  
      // ✅ Third priority: student_acad_year name match
      if (!defaultYear && props.auth.student_acad_year[0]?.acad_yr_name) {
        defaultYear = props.auth.acad_year_list.find(
          (year) => year.inst_acad_year === props.auth.student_acad_year[0]?.acad_yr_name
        );
      }
  
      // ✅ Last fallback: take the last element from the list
      if (!defaultYear) {
        defaultYear = props.auth.acad_year_list[props.auth.acad_year_list.length - 1];
      }
  
      setLocalSelectedYear(defaultYear);
    }
  }, [props.auth.acad_year_list, globalSelectedYear, props.auth.is_institute_type_school]);
  
  

  useEffect(() => {
    if (localSelectedYear) {
      fetchStudentFees(localSelectedYear.inst_acad_year_id);
    }
  }, [localSelectedYear]);
 
  const fetchStudentFees = (inst_acad_year_id, includeTransport = isTransportChecked) => {
    setLoading(true);
    let request = {
      url: `/api/v1/studentWise/fee/${props.auth.institute_id}/students/${props.auth.student_id}/${inst_acad_year_id}`,
      token: props.auth.student_auth,
      params: {
        is_transport_request: includeTransport
      }
    };

    api
      .getAuth(request)
      .then((res) => {
       
        setFeesData(res.data);
        setFineEnable(res.data.result.is_fine_configured)
        setIsTransportApplicable(res.data.result.is_transport_applicable || false)
        setLoading(false);
      })
      .catch((error) => {
        console.log("API Error:", error);
        setLoading(false);
      });
  };
 
// const handleTabChange = (tab) => {

//   setLoading(true);  
//   setActiveTab(tab);

//   setTimeout(() => {
//       setLoading(false);
//   }, 800);
// };



  const handleTabChange = (tab) => {
    setLoading(true);  // ✅ Start Loader when switching tabs
    setActiveTab(tab); // ✅ Change Tab
};

  const handleTransportToggle = (e) => {
    const checked = e.target.checked;
    setIsTransportChecked(checked);
    if (localSelectedYear) {
      fetchStudentFees(localSelectedYear.inst_acad_year_id, checked);
    }
  };


  return (
    <div>
      {loading && <Loader />}
      <Header />
      {/* {console.log(props.auth)} */}
      <div className="container-fluid">
        <div className="fees-header">
          <div className="nav-item" style={{ marginLeft: "32px", display: "flex", alignItems: "center" }}>
          <button
  className={`nav-link ${activeTab === "due" ? "active" : "inactive"}`}
  onClick={() => handleTabChange("due")}
>
  {t('fees.dueDetails')}
</button>
          </div>
          <div className="nav-item" style={{ marginLeft: "32px", display: "flex", alignItems: "center" }}>
          <button
  className={`nav-link ${activeTab === "payment" ? "active" : "inactive"}`}
  onClick={() => handleTabChange("payment")}
>
  {t('fees.paymentHistory')}
</button>
          </div>


          {props.auth.acad_year_list.length > 0 && (
            <div className="header_doc-filter-dropdown-fee">
              <img src={filter} height={15} width={15} />
              <select
                name="academic year"
                onChange={(e) => { setLoading(true);
                  setLocalSelectedYear(JSON.parse(e.target.value))}  }
                value={JSON.stringify(localSelectedYear)}
              >
                {props.auth.acad_year_list.map((item, ind) => (
                  <option key={ind} value={JSON.stringify(item)}>
                    {item.inst_acad_year}
                  </option>
                ))}
              </select>
            </div>
          )}

          {isTransportApplicable && (
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '16px' }}>
              <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px' }}>
                <input
                  type="checkbox"
                  checked={isTransportChecked}
                  onChange={handleTransportToggle}
                  style={{ marginRight: '8px', cursor: 'pointer' }}
                />
                Transport Fees
              </label>
            </div>
          )}
        </div>


        <div className="tab-content mt-3">
          {activeTab === "due" && <Due_details
          fees_payment_chronological_restrict={feesData?.result?.fees_payment_chronological_restrict}
          loading={loading}
          setLoading={setLoading}
          user_phone={props.auth.student_phone}
          user_email={props.auth.email_id}
          fetchStudent={feesData}
          user_id={props.auth.user_id}
          student_fee_enable={props.auth.inst_set_up.enable_razorpay_GST_fee_from_student}
          student_auth={props.auth.student_auth}
          country_id={props.auth.country_calling_code}

          currency_code={props.auth.inst_set_up.currency_code}
          fineEnable={fineEnable}
          is_fee_struct_linked={props.auth.inst_set_up.is_fee_struct_linked}
          is_institute_type_school={props.auth.is_institute_type_school}
          enable_payment={props.auth.inst_set_up.enable_online_payment_feature}
          institute_id={props.auth.institute_id}
          student_id={props.auth.student_id}
          razorpay_fee={props.auth.inst_set_up.razor_payment_gateway_percentage_fee}
          isTransportChecked={isTransportChecked}
          />}
          {activeTab === "payment" && <Payment_history 
          loading={loading}  
          setLoading={setLoading} 
          fetchStudent={feesData} 
          is_fee_struct_linked={props.auth.inst_set_up.is_fee_struct_linked}
          fineEnable={fineEnable}
          inst_acad_year_id={localSelectedYear?.inst_acad_year_id} 
          currency_code={props.auth.inst_set_up.currency_code}
          country_id={props.auth.country_calling_code}
          student_id={props.auth.student_id}
          student_auth={props.auth.student_auth}
          is_institute_type_school={props.auth.is_institute_type_school}
          fee_receipt_option={props.auth.inst_set_up.student_fee_receipt_option}
          />}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({ auth: state.auth });
export default connect(mapStateToProps)(Fees);